import { Box, Grid, Skeleton } from "@mui/material";

export const LoadingLayout = () => {
	return (
		<Box sx={{ p: 3 }}>
			<Grid container spacing={2}>
				{/* Top row: Nurse and Location */}
				<Grid
					size={{
						xs: 12,
						md: 6,
					}}
				>
					<Skeleton variant="rounded" height={56} />
				</Grid>
				<Grid
					size={{
						xs: 12,
						md: 6,
					}}
				>
					<Skeleton variant="rounded" height={56} />
				</Grid>

				{/* Date and Time row */}
				<Grid
					size={{
						xs: 12,
						md: 4,
					}}
				>
					<Skeleton variant="rounded" height={56} />
				</Grid>
				<Grid
					size={{
						xs: 12,
						md: 4,
					}}
				>
					<Skeleton variant="rounded" height={56} />
				</Grid>
				<Grid
					size={{
						xs: 12,
						md: 4,
					}}
				>
					<Skeleton variant="rounded" height={56} />
				</Grid>

				{/* Repeat frequency */}
				<Grid size={{ xs: 6, md: 2 }}>
					<Skeleton variant="rounded" height={56} />
				</Grid>
				<Grid size={{ xs: 6, md: 2 }}>
					<Skeleton variant="rounded" height={56} />
				</Grid>

				{/* Summary line */}
				<Grid size={{ xs: 12 }}>
					<Skeleton variant="text" width="60%" height={30} />
				</Grid>

				{/* Action buttons */}
				<Grid
					size={{ xs: 12 }}
					sx={{
						display: "flex",
						justifyContent: "flex-end",
						gap: 2,
					}}
				>
					<Skeleton variant="rounded" width={100} height={40} />
					<Skeleton variant="rounded" width={100} height={40} />
				</Grid>
			</Grid>
		</Box>
	);
};
